import React from "react";
import { Box, Alert, Typography } from "@mui/material";

export default function SuccessCard({ alert, description, pre }) {
  return (
    <>
      <Box
        sx={{
          mx: "auto",
          mt: 3,
          mb: 3,
          p: 3,
          borderRadius: 2,
          backgroundColor: "#e8f5e9",
          border: "1px solid #4caf50",
        }}
      >
        <Alert severity="success" sx={{ mb: 2 }}>
          {alert}
        </Alert>

        <Typography variant="body1" sx={{ mb: 1 }}>
          {description}
        </Typography>

        <Box
          component="pre"
          sx={{
            whiteSpace: "pre-wrap",
            backgroundColor: "#c8e6c9",
            p: 2,
            borderRadius: 1,
            fontSize: 14,
            color: "#1b5e20",
            border: "1px solid #a5d6a7",
          }}
        >
          {pre}
        </Box>
      </Box>
    </>
  );
}
